export const calcValue = (value: number, min: number, max: number): number => {
  if (min) return value - min
  else if (max) return max - value
  else return value
}

export const roundToPrecision = (
  value: string | number,
  precision: number
): string | number => {
  const baseValue = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(baseValue) || precision < 0) return value

  return (
    Math.round((baseValue + Number.EPSILON) * Math.pow(10, precision)) /
    Math.pow(10, precision)
  ).toString()
}

export const isNumericRegex = (value: string | number | undefined): boolean => {
  return String(value)?.match(/^\d+[.]?[\d]*$/)?.length === 1
}

export const normalizePercent = (val: number): number => {
  // fence val between 0 and 1
  return Math.max(0, Math.min(val || 0, 1))
}

// Format bytes as human-readable text.
export const formatFileSize = (
  bytes: number
): { value: string; unit: string } => {
  if (bytes === 0) return { value: '0.00', unit: 'B' }

  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const value = (bytes / Math.pow(1024, i)).toFixed(2)
  const unit = ['B', 'KB', 'MB', 'GB', 'TB'][i]
  return { value, unit }
}
